import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { login } from "../lib/adminAuth";

export default function AdminLogin() {
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      nav("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--bg-alt))] px-6">
      <form onSubmit={submit} className="w-full max-w-md bg-[hsl(var(--bg))] border border-[hsl(var(--line))] p-10">
        <div className="flex items-center gap-3 mb-8">
          <Lock size={18} className="text-[hsl(var(--accent))]" />
          <div className="kicker">Admin dashboard</div>
        </div>
        <h1 className="font-display text-3xl md:text-4xl leading-tight">
          Sign in to view <span className="italic">analytics</span>.
        </h1>

        <label className="kicker mt-8 block">Username</label>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="mt-3 w-full bg-transparent border-b border-[hsl(var(--line))] focus:border-[hsl(var(--ink))] outline-none py-3 text-lg font-display"
          autoComplete="username"
          required
        />

        <label className="kicker mt-6 block">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-3 w-full bg-transparent border-b border-[hsl(var(--line))] focus:border-[hsl(var(--ink))] outline-none py-3 text-lg font-display"
          autoComplete="current-password"
          required
        />

        {error && (
          <div className="mt-6 text-sm text-[hsl(var(--accent))]">{error}</div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="mt-10 inline-flex items-center gap-3 border border-[hsl(var(--ink))] hover:bg-[hsl(var(--ink))] hover:text-[hsl(var(--bg))] transition-colors duration-500 px-8 py-4 text-[11px] tracking-[0.35em] uppercase disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
